/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/View', 'assets/js/modules/popup/PopupLight'], function($, View, { default: Popup }) {
    return View.extend({
        events: {
            'click .cancel': 'close',
            'submit form': 'submit'
        },

        initialize: function(options) {
            var _this = this;

            this.popup = new Popup(this.$el, {
                width: 800,
                open: function() {
                    _this._getNameInput().val(_this.model.get('currentList').get('name'));
                },
                beforeClose: function() {
                    _this._getNameInput().val('');
                }
            });
        },

        show: function() {
            this.popup.open();
        },

        close: function() {
            this.popup.close();
        },

        submit: function(e) {
            e.preventDefault();
            var name = $.trim(this._getNameInput().val());
            this._getNameInput().val(name);

            if (name) {
                this.close();
                this.trigger('submit', name);
            } else {
                this._getNameInput().focus();
            }
        },

        /**
         * @returns {jQuery}
         * @private
         */
        _getNameInput: function() {
            return this.$el.find('#mailing-list-name');
        }
    });
});
